export const FALLBACK_COPY = {
  en: {
    description:
      "We're performing scheduled maintenance. The service is temporarily unavailable.",
    title: 'Under maintenance',
    until: (time) => `Expected back at ${time}`,
  },
  ja: {
    description:
      'ただいまシステムメンテナンスを行っております。ご不便をおかけして申し訳ございません。',
    title: 'システムメンテナンス中',
    until: (time) => `${time} 頃に復旧予定です`,
  },
  'zh-TW': {
    description: '我們正在進行系統維護，暫時無法使用，造成不便敬請見諒。',
    title: '系統維護中',
    until: (time) => `預計 ${time} 恢復服務`,
  },
};
